/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-use-before-define */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { store } from 'data';
import { logger } from 'services';
import { findDropTargetRange } from './drag-helper';

export class WidgetDropHandlerEditing extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return 'WidgetDropHandlerEditing';
  }

  /**
   * @inheritDoc
   */
  init() {
    const { editor } = this;

    // All clipboard events are handled by CK and made them to a single `clipboardInput`
    editor.editing.view.document.on('clipboardInput', (evt, data: any) => {
      const { dataTransfer } = data;
      const jsonContent = dataTransfer.getData('application/json');

      // If no JSON was pasted, abort and let the clipboard feature handle the input.
      if (!jsonContent) {
        return;
      }

      try {
        const clipboardEventDetails = JSON.parse(jsonContent);

        // If the JSON is not in our expected structure, abort and let the clipboard feature handle the input.
        if (!clipboardEventDetails.ckWidgetCommandName) {
          return;
        }

        if (clipboardEventDetails?.event) {
          const { dispatch } = store;

          dispatch({
            type: clipboardEventDetails?.event?.type,
            payload: clipboardEventDetails?.event?.payload,
          });
        }

        const targetRange = findDropTargetRange(
          editor,
          data.targetRanges,
          data.target,
        );

        editor.execute(clipboardEventDetails.ckWidgetCommandName, {
          ...clipboardEventDetails.options,
          ...clipboardEventDetails.ckWidgetCommandOptions,
          targetRange,
        });

        evt.stop();
      } catch (error) {
        logger.error('WidgetDropHandlerEditing failed', { error });
      }
    });
  }
}
